module.exports = __webpack_public_path__ + "img/surat_eng.fe207f26.png";